import React from 'react'
import { StyleSheet, View } from 'react-native'
import { Color, Text } from 'zens-storybook'
import { useBuildings, useFloors, useLocations, Workspace } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  text: {
    fontSize: 14,
  },
  location: {
    color: Color.metalGrey,
  },
})

interface Props {
  companyId: number
  workspace: Workspace
}
const WorkspaceLocationCell = (props: Props) => {
  const { companyId, workspace } = props
  const { floorId = 0 } = workspace
  const floor = useFloors({ companyId }).data?.find((floor) => floor.id === floorId)
  const building = useBuildings({
    companyId,
  }).data?.find((building) => building.id === floor?.buildingId)
  const location = useLocations({
    companyId,
  }).data?.find((location) => location.id === building?.locationId)

  return (
    <View style={styles.container}>
      <Text style={styles.text}>
        {floor?.displayName} ({building?.name})
      </Text>
      <Text style={[styles.text, styles.location]}>{location?.name}</Text>
    </View>
  )
}

export default WorkspaceLocationCell
